import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/DropzoneTheme.css';
import App from './App';

// Remove any service worker registration that might be attempting to use the manifest

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 